<div class="relative flex h-full flex-col bg-(--mat-sys-surface,#fff) text-(--mat-sys-on-surface,#1a1b1f)">
  <header class="flex shrink-0 items-start justify-between gap-3 px-5 pb-4 pt-8 sm:px-9">
    <div class="min-w-0">
      <h2 class="m-0 pb-2 text-[24px] font-semibold">{{ config.title | translate }}</h2>
      @if (config.description) {
        <p class="mb-0 mt-1 text-sm font-normal text-(--mat-sys-on-surface-variant,#4d5564)">
          {{ config.description | translate }}
        </p>
      }
      @if (config.showRequiredFieldsHint) {
        <p
          class="mb-0 mt-1 text-sm font-normal text-(--mat-sys-on-surface-variant,#4d5564)"
          [innerHTML]="'fields marked required' | translate"
        ></p>
      }
    </div>
    <button
      type="button"
      class="flex size-8 shrink-0 cursor-pointer items-center justify-center rounded border-0 bg-transparent text-(--mat-sys-on-surface-variant,#4d5564) hover:bg-(--mat-color-light-table-hover) hover:text-(--mat-sys-primary)"
      [attr.aria-label]="'close' | translate"
      (click)="requestClose()">
      <i-tabler name="x" class="size-5" />
    </button>
  </header>

  <main class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto">
    <ng-container *ngComponentOutlet="config.formComponent; inputs: config.formInputs ?? {}" />
  </main>

  <footer class="side-panel-sticky-footer flex shrink-0 justify-end gap-[16px] border-t border-(--mat-sys-outline-variant,#e3e6eb) px-5 py-4 sm:py-6 sm:px-9">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      class="h-12! px-6!"
      [ngClass]="config.cancelAction.class"
      [disabled]="isSubmitting"
      (click)="requestClose()">
      @if (config.cancelAction.icon) {
        <i-tabler [name]="config.cancelAction.icon" class="mr-2 size-4" />
      }
      {{ config.cancelAction.text | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      class="h-12! px-6!"
      [ngClass]="config.submitAction.class"
      [disabled]="isSubmitting"
      (click)="submit()">
      <span class="inline-flex items-center justify-center gap-2 leading-none">
        @if (isSubmitting) {
          <i-tabler name="loader-2" class="flex size-4 shrink-0 animate-spin items-center justify-center" />
        } @else if (config.submitAction.icon) {
          <i-tabler [name]="config.submitAction.icon" class="flex size-4 shrink-0 items-center justify-center" />
        }
        <span>{{ config.submitAction.text | translate }}</span>
      </span>
    </button>
  </footer>

  @if (showDiscardConfirmation) {
    <div class="absolute inset-0 z-20 flex items-center justify-center bg-white/75 px-6 backdrop-blur-[1px] dark:bg-[#161b26]/75">
      <section
        role="alertdialog"
        aria-modal="true"
        [attr.aria-label]="'discard changes' | translate"
        class="w-full max-w-81 rounded-xl border border-(--mat-sys-outline-variant,#e3e6eb) bg-(--mat-sys-surface,#fff) p-5! shadow-[0_16px_40px_rgba(16,24,40,0.18)]">
        <h3 class="m-0 text-lg font-semibold">{{ 'discard changes' | translate }}</h3>
        <p class="mb-0 mt-2 text-sm leading-5 text-(--mat-sys-on-surface-variant,#4d5564)">
          {{ 'discard changes message' | translate }}
        </p>
        <div class="mt-5 flex justify-end gap-8">
          <button mat-stroked-button color="primary" type="button" cdkFocusInitial (click)="keepEditing()">
            {{ 'keep editing' | translate }}
          </button>
          <button mat-flat-button color="warn" type="button" class="bg-[#b42318]! text-white!" (click)="discardChanges()">
            {{ 'discard' | translate }}
          </button>
        </div>
      </section>
    </div>
  }
</div>
